import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/styles";
import Card from "components/cards/Card";
import {
  Grid,
  CardContent,
  CardHeader,
  Snackbar,
  Typography,
  Dialog,
  Button,
  DialogTitle,
  DialogActions,
  OutlinedInput,
} from "@material-ui/core";
import { useDispatch } from "react-redux";
import { refreshStorage } from "utils/auth";
import { useHistory } from "react-router-dom";
import { callGetApiWithAuth, callPostApiWithAuth } from "utils/api";
import causesDataTestData from "testdata/causesData";
import { Alert } from "@material-ui/lab";
import { countryName } from "config/var";

export default function DonateCart(props) {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  const [userData, setUserData] = useState(undefined);
  let causesData = [
    ...props.teamList,
    ...causesDataTestData,
  ]
  const CauseData =
    causesData.length > 0
      ? causesData.find((x) => x.id == props.cartData?.product_id)
      : {};

  const [errorMessage, setErrorMessage] = useState("");
  const [loadingMessage, setLoadingMessage] = useState("");
  const [needsOrderConfirm, setNeedsOrderConfirm] = useState(false);

  useEffect(() => {
    loadUserData();
  }, []);

  const loadUserData = () => {
    callGetApiWithAuth("profile", onGetUserData);
  };
  const onGetUserData = (data) => {
    setUserData(data.data);
    dispatch({
      type: "auth.REFRESH",
      payload: { user: data.data },
    });
    refreshStorage(data.data);
  };

  const submitDonation = () => {
    if (userData?.billing_detail) {
      setLoadingMessage("Donating now...");
      if (props.showAllCauses) {
        const data = {
          orderDetails: [
            ...props?.allCauses?.map((el) => {
              return {
                product_id: parseInt(el.product_id),
                quantity: el?.quantity,
                cycle: el?.cycle,
                amount: el?.amount,
              };
            }),
          ],
          payType: 1,
        };
        callPostApiWithAuth(
          "donate",
          data,
          onDonationSuccess,
          onDonationFailure
        );
      } else {
        props.cartData.product_id = parseInt(props.cartData.product_id);
        const data = {
          orderDetails: [
            {
              product_id: props.cartData?.product_id,
              quantity: props.cartData?.quantity,
              cycle: props.cartData?.cycle,
              amount: props.cartData?.amount,
            },
          ],
          payType: 1,
        };
        callPostApiWithAuth(
          "donate",
          data,
          onDonationSuccess,
          onDonationFailure
        );
      }
    } else {
      setErrorMessage("Please fill credit card info and billing info first");
    }
  };

  const onDonationSuccess = (data) => {
    setLoadingMessage(data.message);
    setTimeout(() => {
      history.push("/donation-receipts");
    }, 500);
  };
  const onDonationFailure = (data) => {
    setErrorMessage(data);
    setLoadingMessage("");
  };

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={7} md={7} lg={7} xl={7}>
          <Card className={classes.infoCardView}>
            <CardContent className={classes.cardContent}>
              <CardHeader title="1. User Info" />
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Typography
                    className={classes.outlinedInputLable}
                    component={"h2"}
                  >
                    First Name
                  </Typography>
                  <OutlinedInput
                    className={classes.inputField}
                    placeholder="First Name"
                    value={userData?.first_name}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Typography
                    className={classes.outlinedInputLable}
                    component={"h2"}
                  >
                    Last Name
                  </Typography>
                  <OutlinedInput
                    className={classes.inputField}
                    placeholder="Last Name"
                    value={userData?.last_name}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Typography
                    className={classes.outlinedInputLable}
                    component={"h2"}
                  >
                    Email
                  </Typography>
                  <OutlinedInput
                    className={classes.inputField}
                    placeholder="Email"
                    value={userData?.email}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Typography
                    className={classes.outlinedInputLable}
                    component={"h2"}
                  >
                    Phone
                  </Typography>
                  <OutlinedInput
                    className={classes.inputField}
                    placeholder="Phone"
                    value={userData?.phone}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Typography
                    className={classes.outlinedInputLable}
                    component={"h2"}
                  >
                    Username
                  </Typography>
                  <OutlinedInput
                    className={classes.inputField}
                    placeholder="Username"
                    value={userData?.username}
                    disabled
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
          <div style={{ height: 24 }} />
          <Card className={classes.infoCardView}>
            <CardContent className={classes.cardContent}>
              <CardHeader title="2. Credit Card Info" />
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Typography
                    className={classes.outlinedInputLable}
                    component={"h2"}
                  >
                    Name on Card
                  </Typography>
                  <OutlinedInput
                    className={classes.inputField}
                    placeholder="Name on Card"
                    value={userData?.billing_detail?.cc_name}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Typography
                    className={classes.outlinedInputLable}
                    component={"h2"}
                  >
                    Credit Card Type
                  </Typography>
                  <OutlinedInput
                    className={classes.inputField}
                    placeholder="Credit Card Type"
                    value={userData?.billing_detail?.cc_type == 1 ? "Visa" : userData?.billing_detail?.cc_type == 2 ? "Mastercard" : userData?.billing_detail?.cc_type == 3 ? "Discover" : userData?.billing_detail?.cc_type == 4 ? "Amex" : userData?.billing_detail?.cc_type == 5 ? "Diners" : ""}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Typography
                    className={classes.outlinedInputLable}
                    component={"h2"}
                  >
                    Credit Card Number
                  </Typography>
                  <OutlinedInput
                    className={classes.inputField}
                    placeholder="Credit Card Number"
                    value={
                      userData?.billing_detail?.last_cc_4
                        ? `************${userData.billing_detail?.last_cc_4}`
                        : ""
                    }
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Typography
                    className={classes.outlinedInputLable}
                    component={"h2"}
                  >
                    Exp Date
                  </Typography>
                  <OutlinedInput
                    className={classes.inputField}
                    placeholder="Exp Date"
                    value={userData?.billing_detail?.cc_exp_date}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Typography
                    className={classes.outlinedInputLable}
                    component={"h2"}
                  >
                    Security Code
                  </Typography>
                  <OutlinedInput
                    className={classes.inputField}
                    placeholder="Security Code"
                    value={userData?.billing_detail?.last_cc_4 ? "***" : ""}
                    disabled
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
          <div style={{ height: 24 }} />

          <Card className={classes.infoCardView}>
            <CardContent className={classes.cardContent}>
              <CardHeader title="3. Billing Info" />
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Typography
                    className={classes.outlinedInputLable}
                    component={"h2"}
                  >
                    Address Line 1
                  </Typography>
                  <OutlinedInput
                    className={classes.inputField}
                    placeholder="Address Line 1"
                    value={userData?.billing_detail?.billing_address}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Typography
                    className={classes.outlinedInputLable}
                    component={"h2"}
                  >
                    Address Line 2
                  </Typography>
                  <OutlinedInput
                    className={classes.inputField}
                    placeholder="Address Line 2"
                    value={userData?.billing_detail?.billing_address_line2}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Typography
                    className={classes.outlinedInputLable}
                    component={"h2"}
                  >
                    City
                  </Typography>
                  <OutlinedInput
                    className={classes.inputField}
                    placeholder="City"
                    value={userData?.billing_detail?.billing_city}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Typography
                    className={classes.outlinedInputLable}
                    component={"h2"}
                  >
                    State/Province
                  </Typography>
                  <OutlinedInput
                    className={classes.inputField}
                    placeholder="State/Province"
                    value={userData?.billing_detail?.billing_state}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Typography
                    className={classes.outlinedInputLable}
                    component={"h2"}
                  >
                    Zip/Postal Code
                  </Typography>
                  <OutlinedInput
                    className={classes.inputField}
                    placeholder="Zip/Postal Code"
                    value={userData?.billing_detail?.billing_zipcode}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Typography
                    className={classes.outlinedInputLable}
                    component={"h2"}
                  >
                    Country
                  </Typography>
                  <OutlinedInput
                    className={classes.inputField}
                    placeholder="Country"
                    value={countryName(
                      userData?.billing_detail?.billing_country
                    )}
                    disabled
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
          <button
            className={classes.submitButton}
            onClick={() => setNeedsOrderConfirm(true)}
          >
            DONATE NOW
          </button>
        </Grid>
        <Grid item xs={12} sm={5} md={4} lg={4} xl={4}>
          <Card className={classes.infoCardViews}>
            <CardHeader title="Order Summary" />

            {props.showAllCauses ? (
              props?.allCauses?.map((el) => {
                return (
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <img src={el?.image} className={classes.summaryImage} />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <div className={classes.couseTitle}>{el?.title}</div>
                      <div className={classes.couseFrq}>
                        FREQUENCY:{" "}
                        {el?.cycle == 1
                          ? "ONE-TIME"
                          : el?.cycle == 2
                          ? "WEEKLY"
                          : el?.cycle == 3
                          ? "MONTHLY"
                          : ""}
                      </div>
                      <div
                        className={classes.couseAmount}
                        style={{
                          margin: "4px 0px 10px",
                          textAlign: "end",
                        }}
                      >
                        ${el?.amount}
                      </div>
                    </Grid>
                  </Grid>
                );
              })
            ) : (
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <img
                    src={CauseData?.image}
                    className={classes.summaryImage}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className={classes.couseTitle}>{CauseData?.title}</div>
                  <div className={classes.couseFrq}>
                    FREQUENCY:{" "}
                    {props.cartData?.cycle == 1
                      ? "ONE-TIME"
                      : props.cartData?.cycle == 2
                      ? "WEEKLY"
                      : props.cartData?.cycle == 3
                      ? "MONTHLY"
                      : ""}
                  </div>
                </Grid>
                {/* <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                <div className={classes.couseAmount}>${props.cartData?.amount}</div>
              </Grid> */}
              </Grid>
            )}
            <Grid
              container
              spacing={3}
              className={classes.summaryAmountContainer}
            >
              <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                <div className={classes.couseAmount}>Total</div>
              </Grid>
              <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                <div
                  className={classes.couseAmount}
                  style={{ textAlign: "right" }}
                >
                  $
                  {props.showAllCauses
                    ? props.cartData?.amount * 4
                    : props.cartData?.amount}
                </div>
              </Grid>
            </Grid>
          </Card>
        </Grid>
      </Grid>

      <Dialog
        open={needsOrderConfirm}
        onClose={() => {
          setNeedsOrderConfirm(false);
        }}
      >
        <DialogTitle>Are you sure?</DialogTitle>
        <DialogActions>
          <Button
            color="secondary"
            onClick={() => {
              setNeedsOrderConfirm(false);
            }}
          >
            No
          </Button>
          <Button
            color="primary"
            onClick={() => {
              if (needsOrderConfirm) submitDonation();
              setNeedsOrderConfirm(false);
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        open={loadingMessage}
      >
        <Alert severity="info" variant="filled">
          {loadingMessage}
        </Alert>
      </Snackbar>

      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        open={errorMessage != ""}
        autoHideDuration={2000}
        onClose={(e, r) => {
          if (r == "timeout") setErrorMessage("");
        }}
      >
        <Alert
          severity="error"
          variant="filled"
          onClose={() => setErrorMessage("")}
        >
          {errorMessage}
        </Alert>
      </Snackbar>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  infoCardView: {
    "& .MuiCardContent-root": {
      padding: "10px !important",
    },
    // marginTop: 24,
    // '& span': {
    //   fontFamily: 'Proxima Nova, sans-serif !important',
    // },
    "& .MuiCardHeader-root": {
      paddingLeft: "0px !important",
      paddingRight: "0px !important",
      border: "unset",
    },
  },
  infoCardViews: {
    "& .MuiCardContent-root": {
      padding: "10px 20px !important",
    },
    // marginTop: 24,
    // '& span': {
    //   fontFamily: 'Proxima Nova, sans-serif !important',
    // },
    "& .MuiCardHeader-root": {
      paddingLeft: "0px !important",
      paddingRight: "0px !important",
      border: "unset",
    },
  },
  couseTitle: {
    fontSize: 14,
    fontWeight: 600,
    fontFamily: "Poppins, Arial",
    lineHeight: "18px",
  },
  couseAmount: {
    color: "#6C757D",
  },
  couseFrq: {
    fontSize: 11,
    color: "#6C757D",
    fontFamily: "Poppins, Arial",
    paddingTop: 5,
  },
  cardContent: {
    paddingLeft: "0px !important",
    paddingRight: "0px !important",

    "& .MuiCardHeader-root": {
      paddingTop: "0px !important",
    },
  },
  inputField: {
    width: "100%",
    height: 36,
    background: "#F9F9F9",
    fontSize: 14,
    // fontFamily: 'Proxima Nova, sans-serif !important',
  },
  outlinedInputLable: {
    marginBottom: 10,
    fontSize: 14,
  },
  summaryAmountContainer: {
    padding: "20px 0px",
  },
  submitButton: {
    borderRadius: "4px",
    cursor: "pointer",
    margin: "20px 0 0px",
    width: "250px",
    height: "47px",
    fontWeight: "800",
    fontSize: "14px",
    lineHeight: "17px",
    color: "#FFFFFF",
    background: "#3AC7FF",
    border: "0",

    "@media (max-width: 600px)": {
      width: "100%",
    },
  },
  summaryImage: {
    width: "100%",
    height: "100%",
  },
}));
